/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/close-white-2': {
    width: 13,
    height: 14,
    viewBox: '0 0 13 14',
    data: `
      <g clip-path="url(#clip0_587_97)">
        <path d="M1.59998 2L11.6 12" stroke="white" stroke-width="2" stroke-linecap="square"/>
        <path d="M11.6 2L1.59998 12" stroke="white" stroke-width="2" stroke-linecap="square"/>
      </g>
      <defs>
        <clipPath id="clip0_587_97">
          <rect width="12.8" height="12.8" fill="white" transform="translate(0.199951 0.600006)"/>
        </clipPath>
      </defs>
    `
  }
})
